import * as React from "react";
import { useNavigate } from "react-router-dom";
import { RGX } from "../shared/utils";
import { QueryParams } from "../types";
import { routes } from "../constants/appRoutes";

/**
 * hook di verifica dei parametri in query string
 * il token è obbligatorio, se non è presente si viene reindirizzati alla pagina error
 * @returns i parametri email e token in query string
 */
export const useQueryController = () => {

    const navigate = useNavigate();

    const [queryParams, setQueryParams] = React.useState<QueryParams>({ token: "", email: "" });

    React.useEffect(() => {

        const urlParams = new URLSearchParams(window.location.search);
        const token = urlParams.get("token");
        const email = urlParams.get("email");

        if (!RGX.Guid.test(token)) navigate("/" + routes.errors, { replace: true });
        else {
            setQueryParams({ token, email });
        }
    }, [navigate]);

    return queryParams;
}